import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as floorplanActions from '../../FloorplanActions';
import ResponsiveImage from '../../../helpers/responsiveImage/ResponsiveImage';
import './Style';

class GalleryMiniContainer extends Component {
    constructor(props) {
        super(props);

        this.setActiveImage = this.setActiveImage.bind(this);
        this.markers = [];
    }

    componentDidMount () {
        // set initial active slide image for floorplanContainer gallery
        const {
            stages,
            activeStage,
            activeSlideName
        } = this.props;

        if (!activeSlideName.length && stages[activeStage].markers.length) {
            const startFrom = stages[activeStage].beginning
                ? stages[activeStage].beginning
                : 0;
            this.props.floorplanActions.setActiveSlide(
                stages[activeStage].markers[startFrom].file_name
            );
        }
    }

    setActiveImage(name) {
            this.props.floorplanActions.setActiveSlide(name);
    }

    render () {

        const {
            imagesPath,
            imageSizeParams,
            activeSlideName
        } = this.props;

        return (
            <div className="gallery-active-item-component">
                <ResponsiveImage
                    imagesPath={imagesPath}
                    imageSizeParams={imageSizeParams}
                    filename={activeSlideName}
                    lazyLoad={false}/>
            </div>
        )
    }
}

GalleryMiniContainer.propTypes = {
    imagesPath: PropTypes.string,
    imageSizeParams: PropTypes.object,
    stages: PropTypes.array,
    activeStage: PropTypes.number
}

const mapStateToProps = (state) => {
    return {
        imagesPath: state.floorplan.imagesPath,
        imageSizeParams: state.gallery.imageSizeParams,
        stages: state.floorplan.stages,
        activeStage: state.floorplan.activeStage,
        activeSlideName: state.floorplan.activeSlideName
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        floorplanActions: bindActionCreators(floorplanActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GalleryMiniContainer)
